import { Button } from '@/platform/ui';
import { PlusIcon } from '@heroicons/react/24/outline';
import YearValue from './YearValue';

const YearValueList = ({
    items,
    sectorOptions,
    defaultSectorId,
    errors,
    onChange,
    onStructureChange,
}) => {
    const addYearValue = () => {
        // Ignore blank or non-numeric years, otherwise Math.max returns 0 and
        // the new row would be suggested as year 1.
        const years = (items || [])
            .map(child => Number(child.year))
            .filter(year => Number.isInteger(year) && year > 0);

        const nextYear = years.length
            ? Math.max(...years) + 1
            : new Date().getFullYear();

        // Indexed child errors no longer line up once rows shift position.
        onStructureChange?.();

        onChange('children', [
            {
                key: `new-${Date.now()}`,
                id: null,
                year: String(nextYear),
                value: '',
                sector_id: defaultSectorId || '',
            },
            ...(items || []),
        ]);
    };

    const handleChange = (key, field, value) => {
        onChange(
            'children',
            items?.map(child =>
                child.key === key ? { ...child, [field]: value } : child
            )
        );
    };

    const handleDelete = key => {
        onStructureChange?.();

        onChange(
            'children',
            items?.filter(child => child.key !== key)
        );
    };

    return (
        <>
            <div className='my-4 flex items-center justify-between'>
                <h2 className='text-base font-semibold text-gray-900'>
                    Waarden per jaar ({items?.length || 0})
                </h2>
                <Button type='button' onClick={addYearValue}>
                    <PlusIcon className='size-5' />
                    Jaarwaarde toevoegen
                </Button>
            </div>

            {items?.map((child, index) => (
                <YearValue
                    key={child.key}
                    child={child}
                    sectorOptions={sectorOptions}
                    errors={{
                        year: errors?.[`children.${index}.year`],
                        value: errors?.[`children.${index}.value`],
                        sector_id: errors?.[`children.${index}.sector_id`],
                    }}
                    onChange={handleChange}
                    onDelete={handleDelete}
                />
            ))}
        </>
    );
};

export default YearValueList;
